import ThumbsSurveyPanel from '@/components/thumbs-survey-panel/thumbsSurveyPanel';
import { SurveyProvider } from '@/context/SurveyContext';
import Page from '@/layout/page/Page';
import { Box, Divider } from 'ui/mui';
import { RouteType } from './types';

interface RouteElementProps {
  route: RouteType;
  children: React.ReactNode;
}

const RouteElement = ({ route, children }: RouteElementProps) => (
  <Page key={route.path} route={route}>
    <SurveyProvider>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        {children}
        <ThumbsSurveyPanel surveyOptions={route.surveyOptions} />
      </Box>
    </SurveyProvider>
  </Page>
);

export default RouteElement;
